var parent = require('../../es/object/get-own-property-descriptors');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/get-own-property-descriptors.js
// module id = 581
// module chunks = 0 1